import axios, {AxiosRequestConfig} from "axios";
import {OidcProviderInfo} from "../model";

let oidcProviderInfo: OidcProviderInfo;

export const startOidcProvider = async (studio: string): Promise<OidcProviderInfo> => {
  const baseUrl = getContextPath().replace(studio, "");
  const urlToConfig = baseUrl + "/actuators/apolloConfig";
  oidcProviderInfo = {
    clientId: "",
    authorizationEndpoint: "",
    tokenEndpoint: "",
    logoutEndpoint: "",
    redirectUri: "",
    scope: "",
    issuer: "",
    jwkSetEndpoint: "",
    userInfoEndpoint: "",
    enabled: false
  };
  const init: AxiosRequestConfig = {
    method: "GET",
    headers: {'Content-Type': 'application/json'}
  };
  try {
    const response = await axios.get(urlToConfig, init);
    oidcProviderInfo = response.data;
    return oidcProviderInfo;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return oidcProviderInfo;
    }
  }
};

/**
 * Returns the context path of the application.
 */
const getContextPath = () => {
  //this assumes the BASE_URL is accessible as ".." (relative to index.html)
  const path = window.location.pathname; // /app/foo/bar/studio/#/services/1
  return path.slice(0, path.indexOf("/studio")); //strip everything after /studio
};
export {oidcProviderInfo};
